"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypographyContent = exports.PenIcon = exports.GridStyled = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const PenIcon = exports.PenIcon = (0, _mui.styled)(_icons.Pen)({
  fontSize: '25px'
});
const TypographyContent = exports.TypographyContent = (0, _mui.styled)(_mui.Typography)({
  display: 'flex',
  alignItems: 'center'
});
const GridStyled = exports.GridStyled = (0, _mui.styled)(_mui.Grid)(({
  theme
}) => ({
  alignItems: 'center',
  justifyContent: 'space-between'
}));
